//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PID.js";
import "../no/Builder.js";
import "../Diagramming/Diagramming.TextStyleBuilder.js";
import "../no/ugmath.js";
import "../no/PDM.js";
import "../no/Diagramming.js";
let d=[[[0,"ElementId",1,0],[0,"Horizontal",0,0],[0,"OwningSheet",1,"PID.Sheet",0],[0,"RotateOption",1,0],[0,"Style",1,0],[1,"TextStyleBuilder",0,"Diagramming.TextStyleBuilder",0],[0,"Vertical",0,0]],[[[],"Rotate",{},0,0],[[],"FlipHorizontally",{},0,0],[[],"FlipVertically",{},0,0],[[],"GetLocation",{R_:{location:''}},0,0],[["location"],"SetLocation",{},1,0],[["type","connection","connectionId"],"SetConnection",{},3,0],[["type","connection","connectionId"],"GetConnection",{},0,0],[["desObject"],"LinkOSC",{},1,0],[[],"GetNode",{R_:{node:"Diagramming.Node"}},0,0]],[]];
SPLM.PID.OffSheetConnectorBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PID.OffSheetConnectorBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PID.OffSheetConnectorBuilder.StyleOption = Object.freeze({
    "SmallFilledArrowOut" : "SmallFilledArrowOut", "SmallFilledArrowIn" : "SmallFilledArrowIn", "Box" : "Box", "ChevronOut" : "ChevronOut", "ChevronIn" : "ChevronIn"});

export default SPLM;